import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const VestsAndCummerbundsCopy = () => (
  <>
    <Layout1x1>
      <h3 className="text-h2">About Our Suit Vests & Cummerbunds</h3>
      <Line />
      <p>
        Generation Tux vests and cummerbunds are available in a variety of colors, styles and patterns. Made from a variety of fabrics,
        these vests and cummerbunds will{' '}
        <Link href="/how-it-works/swatches" className="tracker-text-collection-swatches-221226-163000">
          coordinate easily
        </Link>{' '}
        with suits and tuxedos, bridesmaids, and wedding parties.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Men's Suits Vest Colors, Patterns and Styles</h3>
      <p>
        Choose tux vests with 4 or 5 buttons. With a variety of suit vests from pocketless to flap pockets to besom pockets, there is
        something for everyone's tastes.
      </p>

      <p>
        Pick a vest in a range of patterns from plaid to paisley to a classic solid. In satin twill and classic super 130s merino wool,
        you'll be certain to find a vest that will accentuate our look.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tuxedo Cummerbund Colors and Patterns</h3>
      <p>
        Generation Tux tuxedo cummerbunds come in multiple patterns and colors. Your tuxedo doesn't have to be just black. Available in
        solids and paisley patterns, you'll be able to call attention to your tuxedo in these cummerbunds. In a rainbow of colors, your
        cummerbund will be anything but boring.
      </p>
    </Layout1x1>
  </>
);

export default VestsAndCummerbundsCopy;
